import axios from 'axios'

const api = axios.create({
    //baseURL: `${window.location.protocol}//${window.location.hostname}:8080/genioai-api`
    baseURL: `${process.env.REACT_APP_API}`
    /*
    baseURL: `https://2d10-189-8-121-44.ngrok-free.app/genioai-api`,
    headers: {
        'ngrok-skip-browser-warning': 'true'
    }
        */
});

export default api;